
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

interface ToolbarAction {
  name: string;
  icon: string;
  label: string;
  showlabel: boolean;
  onClick: () => any;
}

interface defaultActionsOnClick {
  actionName: () => any;
}

@Component
export default class GridToobar extends Vue {
  @Prop({ default: true, required: false })
  private showDefalutActions: boolean;

  @Prop({ default: (): any  => [], required: false })
  private notShowWichDefaultActions: string[];

  @Prop({ default: (): any  => {}, required: false })
  private defaultActionsOnClick: any;

  @Prop({ default: (): any  => [], required: false })
  private additionalActions: ToolbarAction[];

  @Prop({ default: (): any  => [], required: false })
  private detailsActions: ToolbarAction[];
  
  @Prop({ default: (): any  => [], required: false })
  private buttons: ToolbarAction[];

  @Prop({ default: false })
  private toolbarButtonsDisabled: boolean;

  @Prop({ default: 'left' , required: false })
  private additionalActionsPosition: string;

  private readonly detailsClickedEventName  = 'detailsActionClicked';
  private readonly actionCickEvent          = 'click:action';
  
  private defaultActions = [
    {
      name: 'baixar',
      icon: 'mdi-content-save',
      label: 'Baixar',
      isVisible: true,
      onClick: (): null => null,
    },
    {
      name: 'imprimir',
      icon: 'mdi-printer',
      label: 'Imprimir',
      isVisible: true,
      onClick: (): null => null,
    },
    {
      name: 'alinhar',
      icon: 'mdi-format-line-spacing',
      label: 'Alinha',
      isVisible: true,
      onClick: (): null => null,
    },
    {
      name: 'refresh',
      icon: 'mdi-refresh',
      label: 'Atualizar',
      isVisible: true,
      onClick: (): null => null,
    },
  ];

  private defaultAdditionalActionsPosition = {
    right: 'right',
    left: 'left',
  }

  // COMPUTED
  private get additionalActionPosition() {
    return this.additionalActionsPosition
  }

  private get additionalActionsPositionProperty() {
    return (this.defaultAdditionalActionsPosition as any)[this.additionalActionsPosition];
  }

  // LIFECYCLE
  private mounted() {
    const defaultActionsToShow = Array.isArray(this.notShowWichDefaultActions) && this.notShowWichDefaultActions.length > 0 ? this.notShowWichDefaultActions : false;

    if (defaultActionsToShow) {
      for (let actionName of defaultActionsToShow) {
        const action = this.defaultActions.find((action) => action.name === actionName);
        if (action) {
          action.isVisible = false;
        }
      }
    }

    if (this.defaultActionsOnClick) {
      for (let defaultAction of this.defaultActions) {
        if (this.defaultActionsOnClick[defaultAction.name]) {
          defaultAction.onClick = this.defaultActionsOnClick[defaultAction.name];
        }
      }
    }
  }

  // METHODS
  private onClickAction(action: ToolbarAction) {
    if (action.onClick) {
      action.onClick();
    }
    
    this.emitClick(this.actionCickEvent, action);
  }

  private onClickAdditionalAction(action: ToolbarAction) {
    this.emitClick(this.detailsClickedEventName, action.onClick)
  }
  
  private emitClick(event: string, value: any = null) {
    this.$emit(event, value);
  }
}
